<template>
  <div class="pagination-nav">
    <Button
      variant="secondary"
      size="sm"
      icon="fas fa-chevron-left"
      @click="$emit('go-to-page', currentPage - 1)"
      :disabled="currentPage === 1 || loading"
      class="pagination-btn"
    >
      Précédent
    </Button>

    <div class="pagination-pages">
      <Button
        v-if="showFirstPage"
        variant="secondary"
        :class="['page-number', { active: currentPage === 1 }]"
        @click="$emit('go-to-page', 1)"
        :disabled="loading"
        size="sm"
      >
        1
      </Button>
      <span v-if="showFirstEllipsis" class="page-ellipsis">...</span>

      <Button
        v-for="page in visiblePages"
        :key="page"
        variant="secondary"
        :class="['page-number', { active: currentPage === page }]"
        @click="$emit('go-to-page', page)"
        :disabled="loading"
        size="sm"
      >
        {{ page }}
      </Button>

      <span v-if="showLastEllipsis" class="page-ellipsis">...</span>

      <Button
        v-if="showLastPage"
        variant="secondary"
        :class="['page-number', { active: currentPage === totalPages }]"
        @click="$emit('go-to-page', totalPages)"
        :disabled="loading"
        size="sm"
      >
        {{ totalPages }}
      </Button>
    </div>

    <Button
      variant="secondary"
      size="sm"
      icon="fas fa-chevron-right"
      @click="$emit('go-to-page', currentPage + 1)"
      :disabled="currentPage === totalPages || loading"
      class="pagination-btn pagination-btn-next"
    >
      Suivant
    </Button>
  </div>
</template>

<script setup>
import Button from '../Button.vue'

defineProps({
  currentPage: Number,
  totalPages: Number,
  visiblePages: Array,
  showFirstPage: Boolean,
  showFirstEllipsis: Boolean,
  showLastPage: Boolean,
  showLastEllipsis: Boolean,
  loading: Boolean
})

defineEmits(['go-to-page'])
</script>

<style scoped>
.pagination-nav {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-pages {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.page-number {
  min-width: 36px;
  height: 36px;
  padding: 0 var(--spacing-sm);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all var(--transition-base);
  font-weight: 500;
}

.page-number:hover:not(:disabled) {
  background: var(--color-bg-secondary);
  border-color: var(--color-primary);
}

.page-number.active {
  background: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
}

.page-number:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-ellipsis {
  padding: 0 var(--spacing-xs);
  color: var(--color-text-tertiary);
  user-select: none;
}

.pagination-btn {
  white-space: nowrap;
}

.pagination-btn-next :deep(button) {
  flex-direction: row-reverse;
}

@media (max-width: 768px) {
  .pagination-nav {
    width: 100%;
    justify-content: space-between;
  }
  
  .pagination-pages {
    order: 3;
    width: 100%;
    justify-content: center;
    margin-top: var(--spacing-sm);
  }
  
  .pagination-btn {
    flex: 1;
    min-width: 100px;
  }
}

@media (max-width: 480px) {
  .page-number {
    min-width: 32px;
    height: 32px;
    font-size: 0.85rem;
    padding: 0 var(--spacing-xs);
  }

  .pagination-pages {
    gap: var(--spacing-xs);
  }
}
</style>
